import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "../../Context/GlobalState";
import { Dropdown, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Trans } from "react-i18next";
import userAvtar from "../../../assets/images/user.png";
import "react-toastify/dist/ReactToastify.css";
import { Redirect } from "react-router";
import {
  BASE_URL_AGENT,
  BASE_URL_API,
  BASE_URL_API_TRANXT,
  BASE_URL_API_TRANXT_API,
  BASE_URL_PAYNOW,
} from "../../utils/Constants";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { COMPANY_NAME_NAVBAR } from "../../utils/StringConstants";
import { basicAuth } from "../../config";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { getLatLong, getMyIPAddress, getClientIP } from "../../utils/utilFuctions";

const Navbar = () => {
  const history = useHistory();
  const { user, removeUserInfo } = useContext(GlobalContext);
  const [myAccountInfo, setMyAccountInfo] = useState(null);
  const { username, password } = basicAuth;
  const [menus, setMenus] = useState([]);
  const [subMenus, setSubMenus] = useState([]);
  const [activeMenuId, setActiveMenuId] = useState(null);

  const [navLoading, setNavLoading] = useState(false);

  const getAccountInfo = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    const userId = sessionStorage.getItem("userId");
    console.log("called user id", userId);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${accessToken}`);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8Knu5GvxZz1PqShq3i6d-iza8XwzTtDsnycoa_JEX2ahOG_6MqIJje0CyELar_eYNiyc8DVdR7WY3yvlwQ9s5qK-G9UoNP6RdZTPbLL0E4Yy__ZCqoFSpUJsPMTzYhGoRbCBLEH3HiICuxNtXPw9IpsW5XRdNUA5lHOG3gBLa-TYZZUXKvhWs78Q25He_Q_MZj04E463t-zUOMNPH_2V9-HWesyARkYFQM9VWEp9jX0s96Zs-yKSE6RKVeiQVbD3QZbMk0tL6DKEREfo0FCVYaOMIGMvKX0GFGsPCXD7L63RcOqMuUCAUU2g1MenEVAWVqlP98WGqkSBtzkDMllZH809ERbz8nKyN9PlkAsXpj2KtJ2OnqWQ2_qr9UH-eFMBMtmRZ4Rcz3qP_Njkx4uwF9MOPeX9EGCoEqOcxTjp9jdC2GWIBON2t0K_Rz7tGFMXe8qGFpeOIZ9DKIZhcVeXiBOb70OBWIcsXQdPr-3rRRTePDDSieVuXUSWR2GnjosxJJqEvCga-MbD59KKJEOJ8cYr2E6dImBGcQuix6g8YCT_eijrXPKNEhZQttEzxYoe-0s0OypnpXEeuOnx9uKta06fT31SqLNomWInObIItLRF4mqH5ZNmnnKxHCatj8r4o7EUKlPTq9fH7D3F7w_Z6KENoOfTC2kz1q5VE7GHM78z"
    );

    var raw = JSON.stringify({
      userId: userId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const res = await fetch(
        `${BASE_URL_PAYNOW}${API_ENDPOINTS.PROFILE_INFO}`,
        requestOptions
      );
      const data = await res.json();
      console.log(data);
      setMyAccountInfo(data.data);
    } catch (error) { }
  };

  const generateToken = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Cookie",
      ".AspNetCore.Identity.Application=CfDJ8JsnH411h-hPvOBmxZ5uxqP6rp2ytIifypwWZTazYqnFXDYohzj3JhFUoUEyEcGcfpXoK2-0ijf3BfPQJXY7Nk86kTqeOrMMhiG8TINrH5E2C_nKDsku7O4JS7yDc2tSweTku1oPbP1jYCQ7aXuXI4rWYFu_iikYclB72RfTjJLAF64UAjWZ_va2rZZ_wvLHItEF2zvWTMqKayPDzIc44DwsgDYpPhaj4mDx1kNNk1OiItKIvPzVRU3DVcNiC2PckNQw2lVRod5mMErEu_LUI728kGjTcARb2vYmffdusRK-1f2thw0FOBPimLZTJq16HFGx8wBKNEgVSZJD-IwAym8IFHQgw-_FdhFBBzIdj4ovd8cbLbqBBIF_dJmVvCHL5a08sEcFeJcoa_HSYFlQDMF57fvS_EOVvnAe8SQz5l2BUuPk8Zwq0S1aePx6e0xY09i9l-g5zMPZgvX-cALm-TtrvhVKUkvnM2gXYabjX0po2NmepBzeSwioEcsuOZpTFGfcDwKlIXKclnPYGvVuVlSS1aJRFpKBzJu0SpbFIwKKab7W9nYwU752JuiZFIrZKJCa2G8kRo7P3qPHKAMFNbwfCNEVIbB5A_GwBU2pzhTVUeLiHcPkvFgxcGn1m_nzmxqivZyTey5K7Qvhhv38mESKZytL-ZOmLU-3Bggomr9d"
    );

    var raw = JSON.stringify({
      email: username,
      password: password,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const result = await fetch(
        `${BASE_URL_PAYNOW}${API_ENDPOINTS.ACCOUNT_LOGIN}`,
        requestOptions
      );
      if (result.ok) {
        const body = await result.text();
        const data = JSON.parse(body);
        if (data.userName != undefined) {
          sessionStorage.setItem("userName", data.userName);
        }
        if (data.role != undefined) {
          sessionStorage.setItem("role", data.role);
        }
        if (data.userId != undefined) {
          sessionStorage.setItem("userId", data.userId);
        }
        if (data.accessToken != undefined) {
          sessionStorage.setItem("accessToken", data.accessToken);
          getAccountInfo();
        }
        if (data.refreshToken != undefined) {
          sessionStorage.setItem("refreshToken", data.refreshToken);
        }
      } else {
        // setInvalid(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRoleDetails = async () => {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4=");
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.pkid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_ROLE_DATA}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setMenus(data.menus);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const fetchSubMenus = async (menuId, route) => {
    if (navLoading) return;

    setNavLoading(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Basic Tm9Nb3JlT3duZXJOYW1lQGJ1bXBweS5jb206SEpwZG1GMFpTQnpkR0YwYVdNZ1ptbHVZV3dnVTNSeWFXNW4=");
      myHeaders.append("Content-Type", "application/json");
      let coords = await getLatLong()
      const ip = await getClientIP();

      var raw = JSON.stringify({
        userid: user.pkid,
        menu: menuId,
        lattitude: coords[0],
        longitude: coords[1],
        ip: ip,

      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.GET_SUBMENU}`,
        requestOptions
      );
      const data = await res.json();

      if (data.status == "0") {
        setSubMenus(data.sub_menus || []);
        sessionStorage.setItem(
          "sub_menus",
          JSON.stringify(data.sub_menus || [])
        );
      }
      // history.push(route);
    } catch (error) {
      console.log("error", error);
    } finally {
      setNavLoading(false);
    }
  };

  useEffect(() => {
    generateToken();
    getRoleDetails();
  }, []);
  function toggleOffcanvas() {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  }

  //Devtool_security
  useEffect(() => {
    const threshold = 150;

    const detectDevTools = () => {
      const isOpen =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;

      const ui = document.getElementById("secure-ui");

      if (ui) {
        if (isOpen) {
          ui.style.filter = "blur(8px)";
          ui.style.pointerEvents = "none";
          ui.style.userSelect = "none";
        } else {
          ui.style.filter = "none";
          ui.style.pointerEvents = "auto";
          ui.style.userSelect = "auto";
        }
      }
    };

    const interval = setInterval(detectDevTools, 500);
    return () => clearInterval(interval);
  }, []);

  document.addEventListener("contextmenu", (e) => e.preventDefault());
  document.addEventListener("keydown", (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey &&
        e.shiftKey &&
        (e.key === "I" || e.key === "J" || e.key === "C")) ||
      (e.ctrlKey && e.key === "u")
    ) {
      e.preventDefault();
      return false;
    }
  });
  //
  useEffect(() => {
    document.body.style.cursor = navLoading ? "wait" : "default";
  }, [navLoading]);

  return (
    <GlobalContext.Consumer>
      {(state) =>
        state.user == null ||
          state.user.status == "" ||
          state.user.status == "N" ? (
          <Redirect to="/admin" />
        ) : (
          <nav id="secure-ui" className="navbar p-0 fixed-top d-flex flex-row">
            <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
              <button
                className="navbar-toggler align-self-center"
                type="button"
              >
                <Link to="/admin/dashboard">
                  <img
                    src={require("../../../assets/images/company/navbar_logo.png")}
                    style={{ height: "2.5rem" }}
                  />
                </Link>
              </button>

              <ul className="navbar-nav navbar-nav-left ml-3"
                style={{
                  pointerEvents: navLoading ? "none" : "auto",
                  cursor: navLoading ? "not-allowed" : "pointer",
                  opacity: navLoading ? 0.6 : 1
                }}>
                <strong
                  className="cursor-pointer mx-2"
                  onClick={() => history.push("/admin/dashboard")}
                >
                  <Trans>Dashboard</Trans>
                </strong>

                {menus.map((menu) => (
                  <Dropdown
                    alignRight
                    as="li"
                    className="nav-item"
                    key={menu.pk_menu_id}
                    show={activeMenuId === menu.pk_menu_id}
                    onToggle={(isOpen) => {
                      if (!isOpen) setActiveMenuId(null);
                    }}
                  >
                    <Dropdown.Toggle
                      as="a"
                      className="nav-link cursor-pointer no-caret m-1"
                      onClick={(e) => {
                        e.preventDefault();

                        if (activeMenuId === menu.pk_menu_id) {
                          setActiveMenuId(null);
                        } else {
                          fetchSubMenus(menu.pk_menu_id);
                          setActiveMenuId(menu.pk_menu_id);
                        }
                      }}
                    >
                      <div className="navbar-profile">
                        <strong>{menu.menu_title}</strong>
                        <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                      </div>
                    </Dropdown.Toggle>

                    {getMenu(menu.pk_menu_id, history, subMenus)}
                  </Dropdown>
                ))}
              </ul>
              <ul className="navbar-nav navbar-nav-right">
                <Dropdown
                  alignRight
                  as="li"
                  className="nav-item navbar-nav-right"
                >
                  <Dropdown.Toggle
                    as="a"
                    className="nav-link cursor-pointer no-caret m-1"
                    onClick={(e) => {
                      e.preventDefault();
                      }}
                  >
                    <div className="navbar-profile">
                      <img
                        className="img-xs rounded-circle"
                        src={userAvtar}
                        alt="profile"
                        style={{ height: "1.5rem", width: "auto" }}
                      />
                      <p className="mb-0 d-none d-sm-block navbar-profile-name">
                        <Trans>
                          {user == null ? (
                            ""
                          ) : (
                            <div className="d-flex flex-column justify-content-center">
                              <span
                                style={{
                                  fontWeight: "600",
                                  fontSize: "0.8rem",
                                }}
                                className="text-left"
                              >
                                <strong style={{ fontWeight: "800" }}>
                                  {user.name}
                                </strong>
                              </span>
                              <strong
                                style={{
                                  fontWeight: "600",
                                  fontSize: "0.8rem",
                                }}
                                className="text-right"
                              >
                                {`Role : ${user.rolename}`}
                              </strong>
                            </div>
                          )}
                        </Trans>
                      </p>
                      <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    style={{ minWidth: "20rem" }}
                    className="navbar-dropdown preview-list navbar-profile-dropdown-menu"
                  >
                    <Dropdown.Item
                      className="dropdown-item preview-item"
                      onClick={(evt) => {
                        evt.preventDefault();
                        history.push("/admin/my_profile");
                      }}
                    >
                      <div className="preview-thumbnail">
                        <span
                          class="fa fa-gear"
                          style={{ color: "#666666" }}
                        ></span>
                      </div>
                      <div className="preview-item-content">
                        <Trans>My Profile</Trans>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      className="dropdown-item preview-item"
                      onClick={(evt) => {
                        evt.preventDefault();
                        removeUserInfo();
                      }}
                    >
                      <div className="preview-thumbnail">
                        <span
                          class="fa fa-sign-out"
                          style={{ color: "#666666" }}
                        ></span>
                      </div>
                      <div className="preview-item-content">
                        <Trans>Logout</Trans>
                      </div>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                  </Dropdown.Menu>
                </Dropdown>
              </ul>

              <button
                className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
                type="button"
                onClick={toggleOffcanvas}
              >
                <span className="mdi mdi-format-line-spacing"></span>
              </button>
            </div>
          </nav>
        )
      }
    </GlobalContext.Consumer>
  );
};

const getMenu = (menuId, history, subMenus) => {
  if (!Array.isArray(subMenus)) return null;

  const filtered = subMenus.filter(
    (sub) => sub.menu_id == menuId
  );

  if (filtered.length === 0) return null;

  return (
    <Dropdown.Menu
      style={{
        minWidth: "16rem",
        maxHeight: "28rem",
        overflowY: "auto",
        borderRadius: "14px",
        padding: "8px",
        border: "none",
        boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
      }}
    >
      {filtered.map((sub, index) => (
        <React.Fragment key={sub.pk_menu_id}>
          <Dropdown.Item
            as={Link}
            to={sub.menu_url}
            style={{
              padding: "10px 14px",
              borderRadius: "8px",
              fontSize: "0.92rem",
              fontWeight: "500",
              transition: "all 0.2s ease",
              color: "#2c3e50",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#f4f6f9";
              e.target.style.color = "#0d6efd";
              e.target.style.transform = "translateX(4px)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#2c3e50";
              e.target.style.transform = "translateX(0px)";
            }}
          >
            {sub.menu_title}
          </Dropdown.Item>

          {index !== filtered.length - 1 && (
            <Dropdown.Divider
              style={{
                margin: "6px 0",
                opacity: "0.08",
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Dropdown.Menu>
  );
};


export default Navbar;
